"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './RadioButton.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../../../ClearPropsContext/ClearPropsContext.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import '../../RadioGroup.mjs';
import { Radio } from '../Radio/Radio.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';

const RadioButton = flowComponent("RadioButton", (props) => {
  const { children, className, ref, ...rest } = props;
  const rootClassName = clsx(styles.radioButton, className);
  const propsContext = {
    Text: {
      className: styles.label
    },
    Content: {
      className: styles.content
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(Radio, { ...rest, className: rootClassName, ref, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }) }) });
});

export { RadioButton, RadioButton as default };
//# sourceMappingURL=RadioButton.mjs.map
